import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  collection,
  getDocs,
  query,
  where,
  runTransaction,
  doc,
  serverTimestamp,
} from "firebase/firestore";

import {
  onAuthStateChanged,
} from "firebase/auth";

import {
  db,
  auth,
} from "../firebase";

import "../styles/ePOS.css";


// ============================================================
// ePOS
//
// FIREBASE
//
// shopproducts
//   ├── ownerUid
//   ├── shopId
//   ├── shopName
//   ├── name
//   ├── price
//   ├── offerPrice
//   ├── stock
//   ├── unit
//   ├── image
//   ├── imageUrl
//   ├── images
//   ├── category
//   ├── brand
//   └── active
//
// posSales
//   ├── Name
//   ├── Payment_type
//   ├── Date
//   ├── item_name
//   ├── Qty
//   ├── Unit
//   ├── Unit_Price
//   ├── Amount
//   ├── billId
//   ├── ownerUid
//   ├── shopId
//   ├── shopName
//   └── productId
// ============================================================


export default function EPOS() {

  // ==========================================================
  // AUTH
  // ==========================================================

  const [user, setUser] =
    useState(null);

  const [authLoading, setAuthLoading] =
    useState(true);


  // ==========================================================
  // PRODUCTS
  // ==========================================================

  const [products, setProducts] =
    useState([]);

  const [loadingProducts, setLoadingProducts] =
    useState(true);


  // ==========================================================
  // SEARCH
  // ==========================================================

  const [search, setSearch] =
    useState("");


  // ==========================================================
  // CART
  // ==========================================================

  const [cart, setCart] =
    useState([]);


  // ==========================================================
  // CUSTOMER
  // ==========================================================

  const [customerName, setCustomerName] =
    useState(
      "Walk-in Customer"
    );


  // ==========================================================
  // PAYMENT
  // ==========================================================

  const [paymentType, setPaymentType] =
    useState("Cash");


  // ==========================================================
  // SAVING
  // ==========================================================

  const [saving, setSaving] =
    useState(false);


  // ==========================================================
  // MESSAGE
  // ==========================================================

  const [message, setMessage] =
    useState("");

    // ==========================================================
// RECENT BILLS
// ==========================================================

const [recentBills, setRecentBills] =
  useState([]);

const [loadingRecentBills, setLoadingRecentBills] =
  useState(false);

  // ==========================================================
  // AUTH LISTENER
  // ==========================================================

  useEffect(() => {

    const unsubscribe =
      onAuthStateChanged(
        auth,
        (currentUser) => {

          if (currentUser) {

            console.log(
              "================================"
            );

            console.log(
              "ePOS LOGIN"
            );

            console.log(
              "UID:",
              currentUser.uid
            );

            console.log(
              "Name:",
              currentUser.displayName
            );

            console.log(
              "================================"
            );

            setUser(
              currentUser
            );

          } else {

            console.log(
              "ePOS: No logged-in user"
            );

            setUser(null);

          }

          setAuthLoading(false);

        }
      );


    return () =>
      unsubscribe();

  }, []);


  // ==========================================================
  // LOAD PRODUCTS
  // ==========================================================

  async function loadProducts() {

    if (!user?.uid) {
      return;
    }


    try {

      setLoadingProducts(true);


      console.log(
        "================================"
      );

      console.log(
        "ePOS PRODUCT LOADING"
      );

      console.log(
        "OWNER UID:",
        user.uid
      );

      console.log(
        "================================"
      );


      // ------------------------------------------------------
      // PRODUCTS COLLECTION
      // ------------------------------------------------------

      const productsRef =
        collection(
          db,
          "shopproducts"
        );


      // ------------------------------------------------------
      // OWNER QUERY
      // ------------------------------------------------------

      const productsQuery =
        query(
          productsRef,
          where(
            "ownerUid",
            "==",
            user.uid
          )
        );


      const snapshot =
        await getDocs(
          productsQuery
        );


      console.log(
        "Firestore products:",
        snapshot.size
      );


      const list = [];


      // ------------------------------------------------------
      // BUILD PRODUCT LIST
      // ------------------------------------------------------

      snapshot.forEach(
        (productDoc) => {

          const data =
            productDoc.data();


          // --------------------------------------------------
          // IGNORE INACTIVE PRODUCTS
          // --------------------------------------------------

          if (
            data.active === false
          ) {
            return;
          }


          // --------------------------------------------------
          // MRP
          // --------------------------------------------------

          const mrp =
            Number(
              data.price || 0
            );


          // --------------------------------------------------
          // OFFER PRICE
          // --------------------------------------------------

          const offerPrice =
            Number(
              data.offerPrice || 0
            );


          // --------------------------------------------------
          // FINAL SELLING PRICE
          // --------------------------------------------------

          const sellingPrice =
            offerPrice > 0
              ? offerPrice
              : mrp;


          // --------------------------------------------------
          // IMAGE
          // --------------------------------------------------

          let image = "";


          if (
            data.image
          ) {

            image =
              data.image;

          } else if (
            data.imageUrl
          ) {

            image =
              data.imageUrl;

          } else if (
            Array.isArray(
              data.images
            ) &&
            data.images.length > 0
          ) {

            image =
              data.images[0];

          }


          // --------------------------------------------------
          // PRODUCT OBJECT
          // --------------------------------------------------

          list.push({

            id:
              productDoc.id,

            name:
              data.name ||
              "Unnamed Product",

            description:
              data.description ||
              "",

            category:
              data.category ||
              "",

            brand:
              data.brand ||
              "",

            image:
              image,

            price:
              sellingPrice,

            mrp:
              mrp,

            offerPrice:
              offerPrice,

            stock:
              Number(
                data.stock || 0
              ),

            unit:
              data.unit ||
              "pcs",

            ownerUid:
              data.ownerUid ||
              "",

            shopId:
              data.shopId ||
              "",

            shopName:
              data.shopName ||
              "",

          });

        }
      );


      // ------------------------------------------------------
      // SORT ALPHABETICALLY
      // ------------------------------------------------------

      list.sort(
        (a, b) =>
          String(
            a.name
          ).localeCompare(
            String(
              b.name
            ),
            undefined,
            {
              sensitivity:
                "base",
            }
          )
      );


      setProducts(
        list
      );


      console.log(
        "================================"
      );

      console.log(
        "ePOS PRODUCTS"
      );

      console.log(
        "TOTAL:",
        list.length
      );

      console.log(
        list
      );

      console.log(
        "================================"
      );


    } catch (error) {

      console.error(
        "ePOS PRODUCT LOAD ERROR:",
        error
      );


      alert(
        "Unable to load products.\n\n" +
        error.message
      );


      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  }


  // ==========================================================
  // LOAD PRODUCTS AFTER AUTH
  // ==========================================================

  useEffect(() => {

    if (
      authLoading
    ) {
      return;
    }


    if (
      !user?.uid
    ) {

      setProducts([]);

      setLoadingProducts(false);

      return;

    }


    loadProducts();

  }, [
    user?.uid,
    authLoading,
  ]);

// ==========================================================
// LOAD RECENT BILLS AFTER LOGIN
// ==========================================================

useEffect(() => {

  if (
    authLoading
  ) {
    return;
  }


  if (
    !user?.uid
  ) {

    setRecentBills([]);

    return;

  }


  loadRecentBills();

}, [
  user?.uid,
  authLoading,
]);


  // ==========================================================
  // SEARCH RESULTS
  //
  // IMPORTANT:
  // EMPTY SEARCH = EMPTY RESULTS
  //
  // Products are NEVER displayed initially.
  // ==========================================================

  const filteredProducts =
    useMemo(
      () => {

        const text =
          search
            .trim()
            .toLowerCase();


        // ----------------------------------------------------
        // DO NOT SHOW PRODUCTS WHEN SEARCH IS EMPTY
        // ----------------------------------------------------

        if (!text) {
          return [];
        }


        // ----------------------------------------------------
        // SEARCH
        // ----------------------------------------------------

        const results =
          products.filter(
            (product) => {

              const name =
                String(
                  product.name || ""
                )
                  .toLowerCase();


              const category =
                String(
                  product.category || ""
                )
                  .toLowerCase();


              const brand =
                String(
                  product.brand || ""
                )
                  .toLowerCase();


              const description =
                String(
                  product.description || ""
                )
                  .toLowerCase();


              return (
                name.includes(text) ||
                category.includes(text) ||
                brand.includes(text) ||
                description.includes(text)
              );

            }
          );


        // ----------------------------------------------------
        // LIMIT SEARCH RESULTS
        //
        // Keeps the POS compact.
        // ----------------------------------------------------

        return results.slice(
          0,
          12
        );

      },
      [
        products,
        search,
      ]
    );


  // ==========================================================
  // ADD PRODUCT TO CART
  // ==========================================================

  function addToCart(product) {

    const stock =
      Number(
        product.stock || 0
      );


    // --------------------------------------------------------
    // OUT OF STOCK
    // --------------------------------------------------------

    if (
      stock <= 0
    ) {

      alert(
        `"${product.name}" is out of stock.`
      );

      return;

    }


    setCart(
      (currentCart) => {

        const existing =
          currentCart.find(
            (item) =>
              item.productId ===
              product.id
          );


        // ----------------------------------------------------
        // ALREADY IN CART
        // ----------------------------------------------------

        if (existing) {

          const newQty =
            Number(
              existing.qty
            ) + 1;


          if (
            newQty >
            stock
          ) {

            alert(
              `Only ${stock} ${product.unit || "pcs"} available.`
            );

            return currentCart;

          }


          return currentCart.map(
            (item) => {

              if (
                item.productId !==
                product.id
              ) {

                return item;

              }


              return {

                ...item,

                qty:
                  newQty,

                // Refresh latest stock
                stock:
                  stock,

                unitPrice:
                  Number(
                    product.price || 0
                  ),

              };

            }
          );

        }


        // ----------------------------------------------------
        // NEW CART ITEM
        // ----------------------------------------------------

        return [

          ...currentCart,

          {

            productId:
              product.id,

            itemName:
              product.name,

            qty:
              1,

            unit:
              product.unit ||
              "pcs",

            unitPrice:
              Number(
                product.price || 0
              ),

            image:
              product.image ||
              "",

            stock:
              stock,

            ownerUid:
              product.ownerUid,

            shopId:
              product.shopId,

            shopName:
              product.shopName,

          },

        ];

      }
    );


    // --------------------------------------------------------
    // Keep search active
    //
    // This allows the operator to immediately type the
    // next product.
    // --------------------------------------------------------

  }


  // ==========================================================
  // CHANGE QUANTITY
  // ==========================================================

  function changeQuantity(
    productId,
    newQuantity
  ) {

    const qty =
      Number(
        newQuantity
      );


    // --------------------------------------------------------
    // INVALID NUMBER
    // --------------------------------------------------------

    if (
      !Number.isFinite(qty)
    ) {
      return;
    }


    // --------------------------------------------------------
    // ZERO = REMOVE
    // --------------------------------------------------------

    if (
      qty <= 0
    ) {

      removeFromCart(
        productId
      );

      return;

    }


    setCart(
      (currentCart) => {

        return currentCart.map(
          (item) => {

            if (
              item.productId !==
              productId
            ) {

              return item;

            }


            // ------------------------------------------------
            // STOCK LIMIT
            // ------------------------------------------------

            if (
              qty >
              Number(
                item.stock || 0
              )
            ) {

              alert(
                `Only ${item.stock} ${item.unit || "pcs"} available.`
              );

              return item;

            }


            return {

              ...item,

              qty:
                qty,

            };

          }
        );

      }
    );

  }


  // ==========================================================
  // INCREASE QUANTITY
  // ==========================================================

  function increaseQuantity(
    productId
  ) {

    const item =
      cart.find(
        (cartItem) =>
          cartItem.productId ===
          productId
      );


    if (!item) {
      return;
    }


    changeQuantity(
      productId,
      Number(
        item.qty
      ) + 1
    );

  }


  // ==========================================================
  // DECREASE QUANTITY
  // ==========================================================

  function decreaseQuantity(
    productId
  ) {

    const item =
      cart.find(
        (cartItem) =>
          cartItem.productId ===
          productId
      );


    if (!item) {
      return;
    }


    changeQuantity(
      productId,
      Number(
        item.qty
      ) - 1
    );

  }


  // ==========================================================
  // REMOVE FROM CART
  // ==========================================================

  function removeFromCart(
    productId
  ) {

    setCart(
      (currentCart) =>
        currentCart.filter(
          (item) =>
            item.productId !==
            productId
        )
    );

  }


  // ==========================================================
  // CLEAR BILL
  // ==========================================================

  function clearBill() {

    if (
      cart.length === 0
    ) {
      return;
    }


    const ok =
      window.confirm(
        "Clear current bill?"
      );


    if (!ok) {
      return;
    }


    setCart([]);

    setSearch("");

    setMessage("");

  }


  // ==========================================================
  // TOTAL
  // ==========================================================

  const total =
    cart.reduce(
      (
        sum,
        item
      ) => {

        return (
          sum +
          (
            Number(
              item.qty
            ) *
            Number(
              item.unitPrice
            )
          )
        );

      },
      0
    );


  // ==========================================================
  // TOTAL ITEMS
  // ==========================================================

  const totalItems =
    cart.reduce(
      (
        sum,
        item
      ) => {

        return (
          sum +
          Number(
            item.qty || 0
          )
        );

      },
      0
    );

// ==========================================================
// LOAD RECENT BILLS
//
// posSales contains one document per sold product.
// We group documents using billId.
// ==========================================================

async function loadRecentBills() {

  if (!user?.uid) {
    return;
  }

  try {

    setLoadingRecentBills(true);

    console.log(
      "Loading recent bills for:",
      user.uid
    );


    // --------------------------------------------------------
    // GET ALL SALES FOR THIS OWNER
    //
    // We intentionally only use ownerUid here.
    // Sorting is done locally so no composite Firestore
    // index is required.
    // --------------------------------------------------------

    const salesRef =
      collection(
        db,
        "posSales"
      );


    const salesQuery =
      query(
        salesRef,
        where(
          "ownerUid",
          "==",
          user.uid
        )
      );


    const snapshot =
      await getDocs(
        salesQuery
      );


    // --------------------------------------------------------
    // GROUP BY BILL ID
    // --------------------------------------------------------

    const billMap =
      new Map();


    snapshot.forEach(
      (saleDoc) => {

        const data =
          saleDoc.data();


        const billId =
          String(
            data.billId || ""
          );


        if (!billId) {
          return;
        }


        // ----------------------------------------------------
        // CREATE BILL IF NOT EXISTS
        // ----------------------------------------------------

        if (
          !billMap.has(
            billId
          )
        ) {

          billMap.set(
            billId,
            {

              billId:
                billId,

              customerName:
                data.Name ||
                "Walk-in Customer",

              paymentType:
                data.Payment_type ||
                "Cash",

              date:
                data.Date ||
                data.createdAt ||
                null,

              items: [],

              total:
                0,

              totalItems:
                0,

            }
          );

        }


        const bill =
          billMap.get(
            billId
          );


        // ----------------------------------------------------
        // ADD ITEM
        // ----------------------------------------------------

        const qty =
          Number(
            data.Qty || 0
          );


        const amount =
          Number(
            data.Amount || 0
          );


        bill.items.push({

          itemName:
            data.item_name ||
            "Unnamed Product",

          qty:
            qty,

          unit:
            data.Unit ||
            "pcs",

          unitPrice:
            Number(
              data.Unit_Price || 0
            ),

          amount:
            amount,

        });


        // ----------------------------------------------------
        // TOTAL
        // ----------------------------------------------------

        bill.total +=
          amount;


        bill.totalItems +=
          qty;

      }
    );


    // --------------------------------------------------------
    // CONVERT MAP TO ARRAY
    // --------------------------------------------------------

    const bills =
      Array.from(
        billMap.values()
      );


    // --------------------------------------------------------
    // SORT NEWEST FIRST
    // --------------------------------------------------------

    bills.sort(
      (a, b) => {

        const aTime =
          a.date?.toMillis
            ? a.date.toMillis()
            : 0;

        const bTime =
          b.date?.toMillis
            ? b.date.toMillis()
            : 0;

        return (
          bTime -
          aTime
        );

      }
    );


    // --------------------------------------------------------
    // ONLY SHOW LATEST 10
    // --------------------------------------------------------

    setRecentBills(
      bills.slice(
        0,
        10
      )
    );


    console.log(
      "Recent bills:",
      bills.slice(
        0,
        10
      )
    );

  } catch (error) {

    console.error(
      "RECENT BILLS ERROR:",
      error
    );

    setRecentBills([]);

  } finally {

    setLoadingRecentBills(false);

  }

}

  // ==========================================================
  // SAVE BILL
  // ==========================================================

  async function saveBill() {

    // --------------------------------------------------------
    // LOGIN CHECK
    // --------------------------------------------------------

    if (
      !user?.uid
    ) {

      alert(
        "Please login first."
      );

      return;

    }


    // --------------------------------------------------------
    // EMPTY CART
    // --------------------------------------------------------

    if (
      cart.length === 0
    ) {

      alert(
        "Add at least one product to the bill."
      );

      return;

    }


    // --------------------------------------------------------
    // CUSTOMER
    // --------------------------------------------------------

    const finalCustomerName =
      customerName.trim() ||
      "Walk-in Customer";


    try {

      setSaving(true);

      setMessage("");


      // ------------------------------------------------------
      // BILL ID
      // ------------------------------------------------------

      const now =
        new Date();


      const pad =
        (number) =>
          String(
            number
          ).padStart(
            2,
            "0"
          );


      const billId =
        `POS-${now.getFullYear()}`
        +
        pad(
          now.getMonth() + 1
        )
        +
        pad(
          now.getDate()
        )
        +
        "-"
        +
        pad(
          now.getHours()
        )
        +
        pad(
          now.getMinutes()
        )
        +
        pad(
          now.getSeconds()
        )
        +
        "-"
        +
        Math.floor(
          Math.random() * 1000
        );


      console.log(
        "================================"
      );

      console.log(
        "SAVING BILL"
      );

      console.log(
        "BILL ID:",
        billId
      );

      console.log(
        "TOTAL:",
        total
      );

      console.log(
        "================================"
      );


      // ------------------------------------------------------
      // FIRESTORE TRANSACTION
      // ------------------------------------------------------

      await runTransaction(
        db,
        async (transaction) => {

          const productEntries = [];


          // ==================================================
          // STEP 1
          // READ ALL PRODUCTS FIRST
          //
          // This keeps all transaction reads before writes.
          // ==================================================

          for (
            const item of cart
          ) {

            const productRef =
              doc(
                db,
                "shopproducts",
                item.productId
              );


            const productSnap =
              await transaction.get(
                productRef
              );


            // ------------------------------------------------
            // PRODUCT MUST EXIST
            // ------------------------------------------------

            if (
              !productSnap.exists()
            ) {

              throw new Error(
                `Product "${item.itemName}" no longer exists.`
              );

            }


            const product =
              productSnap.data();


            // ------------------------------------------------
            // OWNER SECURITY
            // ------------------------------------------------

            if (
              String(
                product.ownerUid || ""
              ) !==
              String(
                user.uid
              )
            ) {

              throw new Error(
                `You are not allowed to sell "${item.itemName}".`
              );

            }


            // ------------------------------------------------
            // ACTIVE
            // ------------------------------------------------

            if (
              product.active === false
            ) {

              throw new Error(
                `"${item.itemName}" is inactive.`
              );

            }


            // ------------------------------------------------
            // STOCK
            // ------------------------------------------------

            const currentStock =
              Number(
                product.stock || 0
              );


            const requiredQty =
              Number(
                item.qty
              );


            if (
              !Number.isFinite(
                requiredQty
              ) ||
              requiredQty <= 0
            ) {

              throw new Error(
                `Invalid quantity for "${item.itemName}".`
              );

            }


            // ------------------------------------------------
            // STOCK CHECK
            // ------------------------------------------------

            if (
              currentStock <
              requiredQty
            ) {

              throw new Error(
                `${item.itemName}: only ${currentStock} ${product.unit || "pcs"} available.`
              );

            }


            // ------------------------------------------------
            // PRICE
            // ------------------------------------------------

            const mrp =
              Number(
                product.price || 0
              );


            const offerPrice =
              Number(
                product.offerPrice || 0
              );


            const sellingPrice =
              offerPrice > 0
                ? offerPrice
                : mrp;


            // ------------------------------------------------
            // NEW STOCK
            // ------------------------------------------------

            const newStock =
              currentStock -
              requiredQty;


            // ------------------------------------------------
            // SAVE ENTRY FOR LATER
            // ------------------------------------------------

            productEntries.push({

              item:
                item,

              product:
                product,

              productRef:
                productRef,

              sellingPrice:
                sellingPrice,

              currentStock:
                currentStock,

              requiredQty:
                requiredQty,

              newStock:
                newStock,

            });

          }


          // ==================================================
          // STEP 2
          // UPDATE ALL PRODUCT STOCK
          // ==================================================

          for (
            const entry of
            productEntries
          ) {

            transaction.update(
              entry.productRef,
              {

                stock:
                  entry.newStock,

                updatedAt:
                  serverTimestamp(),

              }
            );

          }


          // ==================================================
          // STEP 3
          // CREATE POS SALES DOCUMENTS
          // ==================================================

          for (
            const entry of
            productEntries
          ) {

            const item =
              entry.item;


            const product =
              entry.product;


            const sellingPrice =
              entry.sellingPrice;


            const amount =
              Number(
                item.qty
              ) *
              Number(
                sellingPrice
              );


            const saleRef =
              doc(
                collection(
                  db,
                  "posSales"
                )
              );


            transaction.set(
              saleRef,
              {

                // ------------------------------------------
                // CUSTOMER
                // ------------------------------------------

                Name:
                  finalCustomerName,


                // ------------------------------------------
                // PAYMENT
                // ------------------------------------------

                Payment_type:
                  paymentType,


                // ------------------------------------------
                // DATE
                // ------------------------------------------

                Date:
                  serverTimestamp(),


                // ------------------------------------------
                // ITEM
                // ------------------------------------------

                item_name:
                  product.name ||
                  item.itemName,


                // ------------------------------------------
                // QUANTITY
                // ------------------------------------------

                Qty:
                  Number(
                    item.qty
                  ),


                // ------------------------------------------
                // UNIT
                // ------------------------------------------

                Unit:
                  product.unit ||
                  item.unit ||
                  "pcs",


                // ------------------------------------------
                // UNIT PRICE
                // ------------------------------------------

                Unit_Price:
                  Number(
                    sellingPrice
                  ),


                // ------------------------------------------
                // AMOUNT
                // ------------------------------------------

                Amount:
                  Number(
                    amount
                  ),


                // ------------------------------------------
                // BILL ID
                // ------------------------------------------

                billId:
                  billId,


                // ------------------------------------------
                // PRODUCT ID
                // ------------------------------------------

                productId:
                  item.productId,


                // ------------------------------------------
                // OWNER
                // ------------------------------------------

                ownerUid:
                  user.uid,


                // ------------------------------------------
                // SHOP
                // ------------------------------------------

                shopId:
                  product.shopId ||
                  item.shopId ||
                  "",


                shopName:
                  product.shopName ||
                  item.shopName ||
                  "",


                // ------------------------------------------
                // CREATED
                // ------------------------------------------

                createdAt:
                  serverTimestamp(),

              }
            );

          }

        }
      );


      // ======================================================
      // SUCCESS
      // ======================================================

      console.log(
        "================================"
      );

      console.log(
        "BILL SAVED"
      );

      console.log(
        billId
      );

      console.log(
        "================================"
      );


      setMessage(
        `Bill ${billId} saved successfully.`
      );


      alert(
        `Bill saved successfully!\n\n` +
        `Bill ID: ${billId}\n` +
        `Items: ${totalItems}\n` +
        `Total: ₹${total.toFixed(2)}`
      );


      // ------------------------------------------------------
      // RESET BILL
      // ------------------------------------------------------

      setCart([]);

      setSearch("");

      setCustomerName(
        "Walk-in Customer"
      );

      setPaymentType(
        "Cash"
      );


      // ------------------------------------------------------
      // RELOAD STOCK
      // ------------------------------------------------------

      await loadProducts();

await loadRecentBills();


    } catch (error) {

      console.error(
        "================================"
      );

      console.error(
        "SAVE BILL ERROR"
      );

      console.error(
        error
      );

      console.error(
        "================================"
      );


      alert(
        "Could not save bill.\n\n" +
        error.message
      );

    } finally {

      setSaving(false);

    }

  }


  // ==========================================================
  // AUTH LOADING
  // ==========================================================

  if (
    authLoading
  ) {

    return (

      <div
        className="epos-loading"
      >

        Loading ePOS...

      </div>

    );

  }


  // ==========================================================
  // NOT LOGGED IN
  // ==========================================================

  if (
    !user
  ) {

    return (

      <div
        className="epos-login-message"
      >

        <h2>
          ePOS
        </h2>

        <p>
          Please login to use ePOS.
        </p>

      </div>

    );

  }


  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div
      className="epos-page"
    >

      {/* ================================================== */}
      {/* TOP TITLE */}
      {/* ================================================== */}

      <div
        className="epos-top"
      >

        <div>

          <h1>
            ePOS Billing
          </h1>

          <div
            className="epos-user"
          >

            Logged in as:

            {" "}

            <strong>
              {
                user.displayName ||
                user.email ||
                "User"
              }
            </strong>

          </div>

        </div>

      </div>


      {/* ================================================== */}
      {/* CENTERED BILLING PANEL */}
      {/* ================================================== */}

      <main
        className="epos-billing-wrap"
      >

        <section
          className="epos-billing-card"
        >

          {/* ============================================ */}
          {/* BILL TITLE */}
          {/* ============================================ */}

          <div
            className="epos-billing-header"
          >

            <div>

              <h2>
                Current Bill
              </h2>

              <span>
                {totalItems} item
                {totalItems === 1 ? "" : "s"}
              </span>

            </div>

          </div>


          {/* ============================================ */}
          {/* CUSTOMER */}
          {/* ============================================ */}

          <div
            className="epos-field"
          >

            <label>
              Customer Name
            </label>

            <input
              type="text"
              value={
                customerName
              }
              onChange={(e) =>
                setCustomerName(
                  e.target.value
                )
              }
              placeholder="Customer name"
              autoComplete="off"
            />

          </div>


          {/* ============================================ */}
          {/* PAYMENT */}
          {/* ============================================ */}

          <div
            className="epos-field"
          >

            <label>
              Payment Type
            </label>

            <select
              value={
                paymentType
              }
              onChange={(e) =>
                setPaymentType(
                  e.target.value
                )
              }
            >

              <option value="Cash">
                Cash
              </option>

              <option value="UPI">
                UPI
              </option>

              <option value="Card">
                Card
              </option>

              <option value="Credit">
                Credit
              </option>

            </select>

          </div>


          {/* ============================================ */}
          {/* PRODUCT SEARCH */}
          {/* ============================================ */}

          <div
            className="epos-search-section"
          >

            <label>
              Search Product
            </label>


            <div
              className="epos-search-box"
            >

              <input
                type="text"
                value={
                  search
                }
                onChange={(e) =>
                  setSearch(
                    e.target.value
                  )
                }
                placeholder="Type product name..."
                autoComplete="off"
                autoFocus
              />


              {search && (

                <button
                  type="button"
                  className="epos-search-clear"
                  onClick={() =>
                    setSearch("")
                  }
                  aria-label="Clear search"
                >
                  ×
                </button>

              )}

            </div>


            {/* ======================================== */}
            {/* SEARCHING */}
            {/* ======================================== */}

            {loadingProducts &&
              search.trim() && (

                <div
                  className="epos-search-status"
                >

                  Searching products...

                </div>

              )}


            {/* ======================================== */}
            {/* SEARCH RESULTS */}
            {/* ======================================== */}

            {!loadingProducts &&
              search.trim() &&
              filteredProducts.length > 0 && (

                <div
                  className="epos-search-results"
                >

                  <div
                    className="epos-results-title"
                  >

                    Search Results

                    <span>
                      {filteredProducts.length}
                    </span>

                  </div>


                  <div
                    className="epos-results-list"
                  >

                    {filteredProducts.map(
                      (product) => {

                        const stock =
                          Number(
                            product.stock || 0
                          );


                        const price =
                          Number(
                            product.price || 0
                          );


                        const outOfStock =
                          stock <= 0;


                        const existing =
                          cart.find(
                            (item) =>
                              item.productId ===
                              product.id
                          );


                        return (

                          <button
                            key={
                              product.id
                            }
                            type="button"
                            className={
                              "epos-result-item" +
                              (
                                outOfStock
                                  ? " is-out"
                                  : ""
                              )
                            }
                            disabled={
                              outOfStock
                            }
                            onClick={() =>
                              addToCart(
                                product
                              )
                            }
                          >

                            {/* IMAGE */}

                            <div
                              className="epos-result-image"
                            >

                              {product.image ? (

                                <img
                                  src={
                                    product.image
                                  }
                                  alt=""
                                />

                              ) : (

                                <span>
                                  —
                                </span>

                              )}

                            </div>


                            {/* DETAILS */}

                            <div
                              className="epos-result-details"
                            >

                              <strong>
                                {
                                  product.name
                                }
                              </strong>


                              <span
                                className="epos-result-meta"
                              >

                                {product.category
                                  ? product.category
                                  : product.unit}

                              </span>


                              <span
                                className="epos-result-stock"
                              >

                                {outOfStock
                                  ? "Out of stock"
                                  : `${stock} ${product.unit || "pcs"} available`
                                }

                              </span>

                            </div>


                            {/* PRICE */}

                            <div
                              className="epos-result-price"
                            >

                              <strong>
                                ₹
                                {
                                  price.toFixed(
                                    2
                                  )
                                }
                              </strong>


                              {existing && (

                                <span
                                  className="epos-in-cart"
                                >

                                  ×
                                  {existing.qty}

                                </span>

                              )}

                            </div>


                            {/* ADD */}

                            <div
                              className="epos-result-add"
                            >

                              {outOfStock
                                ? "Out"
                                : existing
                                  ? "Add +"
                                  : "Add"
                              }

                            </div>

                          </button>

                        );

                      }
                    )}

                  </div>

                </div>

              )}


            {/* ======================================== */}
            {/* NO SEARCH RESULTS */}
            {/* ======================================== */}

            {!loadingProducts &&
              search.trim() &&
              filteredProducts.length === 0 && (

                <div
                  className="epos-no-results"
                >

                  <strong>
                    No products found
                  </strong>

                  <span>
                    Try another product name.
                  </span>

                </div>

              )}


            {/* ======================================== */}
            {/* EMPTY SEARCH */}
            {/* ======================================== */}

            {!search.trim() && (

              <div
                className="epos-search-hint"
              >

                Start typing to search products.

              </div>

            )}

          </div>


          {/* ============================================ */}
          {/* CURRENT BILL */}
          {/* ============================================ */}

          <div
            className="epos-current-bill"
          >

            <div
              className="epos-section-title"
            >

              <span>
                Current Bill
              </span>

              {cart.length > 0 && (

                <span>
                  {cart.length} product
                  {cart.length === 1 ? "" : "s"}
                </span>

              )}

            </div>


            {/* ======================================== */}
            {/* EMPTY BILL */}
            {/* ======================================== */}

            {cart.length === 0 ? (

              <div
                className="epos-empty-cart"
              >

                <strong>
                  No products added
                </strong>

                <span>
                  Search and add products above.
                </span>

              </div>

            ) : (

              <div
                className="epos-cart-list"
              >

                {cart.map(
                  (item) => {

                    const amount =
                      Number(
                        item.qty
                      ) *
                      Number(
                        item.unitPrice
                      );


                    return (

                      <div
                        key={
                          item.productId
                        }
                        className="epos-cart-item"
                      >

                        {/* ================================= */}
                        {/* IMAGE */}
                        {/* ================================= */}

                        <div
                          className="epos-cart-image"
                        >

                          {item.image ? (

                            <img
                              src={
                                item.image
                              }
                              alt=""
                            />

                          ) : (

                            <span>
                              —
                            </span>

                          )}

                        </div>


                        {/* ================================= */}
                        {/* DETAILS */}
                        {/* ================================= */}

                        <div
                          className="epos-cart-details"
                        >

                          <strong>
                            {
                              item.itemName
                            }
                          </strong>


                          <span>
                            ₹
                            {
                              Number(
                                item.unitPrice
                              ).toFixed(
                                2
                              )
                            }

                            {" / "}

                            {
                              item.unit
                            }
                          </span>


                          {/* QUANTITY */}

                          <div
                            className="epos-quantity"
                          >

                            <button
                              type="button"
                              onClick={() =>
                                decreaseQuantity(
                                  item.productId
                                )
                              }
                              aria-label="Decrease quantity"
                            >

                              −

                            </button>


                            <input
                              type="number"
                              min="1"
                              max={
                                item.stock
                              }
                              value={
                                item.qty
                              }
                              onChange={(e) =>
                                changeQuantity(
                                  item.productId,
                                  e.target.value
                                )
                              }
                            />


                            <button
                              type="button"
                              onClick={() =>
                                increaseQuantity(
                                  item.productId
                                )
                              }
                              aria-label="Increase quantity"
                            >

                              +

                            </button>

                          </div>

                        </div>


                        {/* ================================= */}
                        {/* AMOUNT */}
                        {/* ================================= */}

                        <div
                          className="epos-cart-amount"
                        >

                          <strong>
                            ₹
                            {
                              amount.toFixed(
                                2
                              )
                            }
                          </strong>


                          <button
                            type="button"
                            className="epos-remove"
                            onClick={() =>
                              removeFromCart(
                                item.productId
                              )
                            }
                          >

                            Remove

                          </button>

                        </div>

                      </div>

                    );

                  }
                )}

              </div>

            )}

          </div>


          {/* ============================================ */}
          {/* TOTAL */}
          {/* ============================================ */}

          <div
            className="epos-total"
          >

            <strong>
              TOTAL
            </strong>

            <strong>
              ₹
              {
                total.toFixed(
                  2
                )
              }
            </strong>

          </div>


          {/* ============================================ */}
          {/* ACTIONS */}
          {/* ============================================ */}

          <div
            className="epos-actions"
          >

            <button
              type="button"
              className="epos-clear-button"
              onClick={
                clearBill
              }
              disabled={
                saving ||
                cart.length === 0
              }
            >

              Clear

            </button>


            <button
              type="button"
              className="epos-save-button"
              onClick={
                saveBill
              }
              disabled={
                saving ||
                cart.length === 0
              }
            >

              {saving
                ? "Saving Bill..."
                : "Save Bill"
              }

            </button>

          </div>


          {/* ============================================ */}
          {/* MESSAGE */}
          {/* ============================================ */}

          {message && (

            <div
              className="epos-success"
            >

              {message}

            </div>

          )}

        </section>

      </main>


      {/* ================================================== */}
      {/* RECENT BILLS */}
      {/* ================================================== */}

      <section
        className="epos-recent-section"
      >

        <div
          className="epos-recent-header"
        >

          <div>

            <h2>
              Recent Bills
            </h2>

            <span>
              Latest 10 bills
            </span>

          </div>

        </div>


        {/* ================================================ */}
        {/* LOADING */}
        {/* ================================================ */}

        {loadingRecentBills && (

          <div
            className="epos-recent-loading"
          >

            Loading recent bills...

          </div>

        )}


        {/* ================================================ */}
        {/* NO BILLS */}
        {/* ================================================ */}

        {!loadingRecentBills &&
          recentBills.length === 0 && (

            <div
              className="epos-no-bills"
            >

              <strong>
                No recent bills
              </strong>

              <span>
                Saved bills will appear here.
              </span>

            </div>

          )}


        {/* ================================================ */}
        {/* BILL LIST */}
        {/* ================================================ */}

        {!loadingRecentBills &&
          recentBills.length > 0 && (

            <div
              className="epos-recent-list"
            >

              {recentBills.map(
                (bill) => (

                  <div
                    key={
                      bill.billId
                    }
                    className="epos-recent-bill"
                  >

                    {/* ================================= */}
                    {/* BILL HEADER */}
                    {/* ================================= */}

                    <div
                      className="epos-recent-bill-header"
                    >

                      <div>

                        <strong>
                          {bill.billId}
                        </strong>

                        <span>
                          {
                            bill.customerName
                          }
                        </span>

                      </div>


                      <div
                        className="epos-recent-total"
                      >

                        ₹
                        {
                          bill.total.toFixed(
                            2
                          )
                        }

                      </div>

                    </div>


                    {/* ================================= */}
                    {/* BILL INFO */}
                    {/* ================================= */}

                    <div
                      className="epos-recent-info"
                    >

                      <span>

                        {
                          bill.date?.toDate
                            ? bill.date
                                .toDate()
                                .toLocaleString(
                                  "en-IN",
                                  {
                                    day:
                                      "2-digit",

                                    month:
                                      "short",

                                    year:
                                      "numeric",

                                    hour:
                                      "2-digit",

                                    minute:
                                      "2-digit",

                                  }
                                )
                            : "Date unavailable"
                        }

                      </span>


                      <span>
                        {
                          bill.paymentType
                        }
                      </span>


                      <span>

                        {
                          bill.totalItems
                        }
                        {" "}
                        item
                        {
                          bill.totalItems === 1
                            ? ""
                            : "s"
                        }

                      </span>

                    </div>


                    {/* ================================= */}
                    {/* ITEMS */}
                    {/* ================================= */}

                    <div
                      className="epos-recent-items"
                    >

                      {bill.items.map(
                        (
                          item,
                          index
                        ) => (

                          <div
                            key={
                              index
                            }
                            className="epos-recent-item"
                          >

                            <div>

                              <strong>
                                {
                                  item.itemName
                                }
                              </strong>

                              <span>

                                ×
                                {
                                  item.qty
                                }

                                {" "}

                                {
                                  item.unit
                                }

                              </span>

                            </div>


                            <strong>

                              ₹
                              {
                                item.amount.toFixed(
                                  2
                                )
                              }

                            </strong>

                          </div>

                        )
                      )}

                    </div>

                  </div>

                )
              )}

            </div>

          )}

      </section>

    </div>
    

  );

}